import { Component } from '@angular/core';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { EmsServicesService } from 'src/app/module/ems-master/services/ems-services.service';

interface WarehouseDetail {
  label: string;
  value: string;
}

interface Warehouse {
  name: string;
  details: WarehouseDetail[];
  address?: string;
  filteredDetails?: WarehouseDetail[];
}

interface AddressItem {
  label: string;
  value: string;
}

@Component({
  selector: 'app-customers-view',
  templateUrl: './customers-view.component.html',
  styleUrls: ['./customers-view.component.css'],
})
export class customersViewComponent {
  theme = 'dark';
  // userType = 'employee';
  userType = 'customer';
  // userType = 'vendor';
  billingAddress: AddressItem[] = [
    { label: 'Street', value: '123 Billing Street' },
    { label: 'City', value: 'Mumbai' },
    { label: 'Pincode', value: '400001' },
    { label: 'State', value: 'Maharashtra' }
  ];

  shippingAddress: AddressItem[] = [
    { label: 'Street', value: '456 Shipping Road' },
    { label: 'City', value: 'Pune' },
    { label: 'Pincode', value: '411001' },
    { label: 'State', value: 'Maharashtra' }
  ];
  warehouses: Warehouse[] = [
    {
      name: 'Warehouse 1',
      details: [
        { label: 'Code', value: 'WH-001' },
        { label: 'Address', value: '123 Industrial Area' },
        { label: 'City', value: 'Mumbai' },
        { label: 'Pincode', value: '400001' },
        { label: 'State', value: 'Maharashtra' },
        { label: 'Latitude', value: '19.0760' },
        { label: 'Longitude', value: '72.8777' },
        { label: 'GSTIN', value: '27ABCDE1234F1Z5' }
      ]
    },
    {
      name: 'Warehouse 2',
      details: [
        { label: 'Code', value: 'WH-001' },
        { label: 'Address', value: '123 Industrial Area' },
        { label: 'City', value: 'Mumbai' },
        { label: 'Pincode', value: '400001' },
        { label: 'State', value: 'Maharashtra' },
        { label: 'Latitude', value: '19.0760' },
        { label: 'Longitude', value: '72.8777' },
        { label: 'GSTIN', value: '27ABCDE1234F1Z5' }
      ]
    },
    {
      name: 'Warehouse 3',
      details: [
        { label: 'Code', value: 'WH-001' },
        { label: 'Address', value: '123 Industrial Area' },
        { label: 'City', value: 'Mumbai' },
        { label: 'Pincode', value: '400001' },
        { label: 'State', value: 'Maharashtra' },
        { label: 'Latitude', value: '19.0760' },
        { label: 'Longitude', value: '72.8777' },
        { label: 'GSTIN', value: '27ABCDE1234F1Z5' }
      ]
    }
  ];

  experience = [
  {
    company: 'Google',
    role: 'Software Engineer',
    location: 'Bangalore, India',
    duration: '2019 - Present',
    description: 'Worked on scalable backend systems and cloud architecture.'
  },
  {
    company: 'Infosys',
    role: 'Developer',
    location: 'Pune, India',
    duration: '2017 - 2019',
    description: 'Contributed to enterprise client apps and migration projects.'
  }
];
  UserDetails: any;
  pageSize = 10; // Number of items per page
  pageNumber = 0;
  sortingCol: string = 'id';
  direction: string = 'DESC'
  filters: any[] = [];
  tableLists: any;
  accountIds: any;
  locationIds:any;
  customerData: any;

  // UserDetails: { address: string; filteredDetails: WarehouseDetail[]; name: string; details: WarehouseDetail[]; }[];
constructor(private emsServices : EmsServicesService,
      public config: DynamicDialogConfig,
  
 
){
   this.customerData = this.config.data.rowData;
    // this.columns = this.config.data.columns;
}

  ngOnInit() {
    this.UserDetails =  JSON.parse(localStorage.getItem('UserDetails') || '{}');
    console.log(this.UserDetails, this.customerData)
    // Preprocess warehouses to create address and filtered details
    this.warehouses = this.warehouses.map(warehouse => {
      if (!warehouse.details) {
        return {
          ...warehouse,
          address: 'N/A',
          filteredDetails: []
        };
      }

      const addressDetail = warehouse.details.find(d => d.label === 'Address')?.value || 'N/A';
      const cityDetail = warehouse.details.find(d => d.label === 'City')?.value || 'N/A';
      const pincodeDetail = warehouse.details.find(d => d.label === 'Pincode')?.value || 'N/A';

      return {
        ...warehouse,
        address: `${addressDetail}, ${cityDetail} - ${pincodeDetail}`,
        filteredDetails: warehouse.details.filter(
          d => !['Address', 'City', 'Pincode'].includes(d.label)
        )
      };
    });

    this.accountIds = Array.from(new Set(this.UserDetails.accountMapping.map((m:any) => m.accountId)));
    this.locationIds = Array.from(new Set(this.UserDetails.accountMapping.map((m:any) => m.accountLocationMappingId)));

   

    this.getList()
  }


   getList() {
     // Format as desired array
    const filters = [
      { key: 'ACCOUNT_ID_IN', value: this.accountIds.join(',') },
      // { key: 'accountLocationMappingId', value: this.locationIds.join(',') },
    ];   
    this.filters = filters.filter(f => {
      if (f.value === null || f.value === undefined) return false;
      if (typeof f.value === 'string' && f.value.trim() === '') return false;
      if (Array.isArray(f.value) && f.value.length === 0) return false;
      return true;
    });
    this.emsServices
      .getAccounts(this.filters, this.pageNumber, this.pageSize, this.sortingCol, this.direction)
      .subscribe((data: any) => {
        this.tableLists = data?.responseObject?.content;
        console.log(this.tableLists)
      }, err => {
        // console.log(err);
        this.tableLists = []
      });
  }

}
